export default __webpack_public_path__ + "static/jellow-front-min-c51705089c677f50904964b2970db29c.png";